"use strict";

exports.__esModule = true;
exports.getColorPalette = exports.TIMESTAMP_FORMAT = exports.STEP_AFTER = exports.SCATTER_CHART = exports.LINE_CHART = exports.LINEAR = exports.ChartClasses = void 0;
/**
 * Types of Charts
 * */
var LINE_CHART = exports.LINE_CHART = "LINE_CHART";
var SCATTER_CHART = exports.SCATTER_CHART = "SCATTER_CHART";

/**
 * Types of Curves for Line Chart
 * */

var LINEAR = exports.LINEAR = "linear";
var STEP_AFTER = exports.STEP_AFTER = "stepAfter";

/* Recharts Classes */
var ChartClasses = exports.ChartClasses = {
  X_AXIS: "recharts-xAxis",
  Y_AXIS: "recharts-yAxis",
  BRUSH_SLIDE: "recharts-brush-slide",
  LEGEND_WRAPPER: "recharts-legend-wrapper",
  LEGEND_ITEM: "recharts-legend-item"
};
var colorPaletteLight = ["#729ECE", "#FF9E4A", "#67BF5C", "#ED665D", "#AD8BC9", "#A8786E", "#ED97CA", "#A2A2A2", "#CDCC5D", "#6DCCDA"];
var colorPaletteDark = ["#AEC7E8", "#FFBB78", "#98DF8A", "#FF9896", "#C5B0D5", "#C49C94", "#F7B6D2", "#C7C7C7", "#DBDB8D", "#9EDAE5"];
var getColorPalette = exports.getColorPalette = function getColorPalette(themeName) {
  switch (themeName) {
    case "sandvik":
      return colorPaletteDark;
    case "sandvik-v2":
      return colorPaletteDark;
    default:
      return colorPaletteLight;
  }
};
var TIMESTAMP_FORMAT = exports.TIMESTAMP_FORMAT = "YYYY-MM-DD HH:mm:ss";